export const getExpensePdfUrl = (expenseId: number): string =>
  `/status/expense-report/${expenseId}/pdf/`
